var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "transition-all duration-300 ease-out",
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_8)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.5H0V24.5H18V6.5L12 0.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_406_8",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.5H0V24.5H18V6.5L12 0.5Z",
    fill: "#FFCC2B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_406_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V-0.5H-1V0.5H0ZM12 0.5L12.7071 -0.207107L12.4142 -0.5H12V0.5ZM0 24.5H-1V25.5H0V24.5ZM18 24.5V25.5H19V24.5H18ZM18 6.5H19V6.08579L18.7071 5.7929L18 6.5ZM0 1.5H12V-0.5H0V1.5ZM1 24.5V0.5H-1V24.5H1ZM18 23.5H0V25.5H18V23.5ZM17 6.5V24.5H19V6.5H17ZM11.2929 1.20711L17.2929 7.20711L18.7071 5.7929L12.7071 -0.207107L11.2929 1.20711Z",
    fill: "#FFCC2B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e8569fd44d1694d08bf19f8a25363ec4.svg";
export { ForwardRef as ReactComponent };